/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// BSS fix
if (typeof BSS_B2B && window.location.pathname === '/pages/b2b') {
  document.addEventListener("DOMContentLoaded", () => {
    const firstNameField = document.querySelector("#RegisterForm-FirstName");
    const lastNameField = document.querySelector("#RegisterForm-LastName");
    const emailField = document.querySelector("#RegisterForm-email");
    const passwordField = document.querySelector("#RegisterForm-password");
    if (firstNameField && lastNameField && emailField && passwordField) {
      firstNameField.placeholder = "First Name";
      lastNameField.placeholder = "Last Name";
      emailField.placeholder = "Email";
      passwordField.placeholder = "Password "
    }
  })
}
// BSS end fix